import(/* webpackMode: "eager" */ "E:\\VQBits_Windows\\fireserve-main\\src\\app\\customer-mobile\\page.tsx");
